<template>
  <div class="container-fluid" style="height:100vh;width:100vw;">
    <div class="row">
      <div class="col-lg-2 col-md-2" style="paddingLeft:0px; paddingRight:0px;">
        <Sidebar />
      </div>
      <div class="col-lg-10 col-md-10 col-12 mt-2 cust">
        <div class="row h3 pl-4">All Customers</div>
        <div class="row allCustRow">
          <div
            class="col-lg-12 pt-2 col-12 text-center"
            v-for="customer in customers"
            v-bind:key="customer._id"
          >
            <div class="col-lg-12 mt-3 custcol">
              <div class="row p-2">
                <div class="col-sm-3 col-md-6">
                  <div class="col-md-6 text-left" style="fontSize:0.9rem;fontWeight:500">
                    <div>Customer Name</div>
                  </div>
                  <router-link :to="'/custInfo/'+customer.name+'/'+customer._id" class="rlink">
                    <div
                      class="col-lg-12 text-left pt-2 custNm"
                    >{{customer.name ? customer.name.toLowerCase() :''}}</div>
                  </router-link>
                </div>
                <div class="col-md-6">
                  <div class="row pt-2">
                    <div class="col-md-4">
                      <div class="row">
                        <div class="col-sm-12 total text-center" style="color:#2295c8">
                          <div>Total</div>
                        </div>
                        <div
                          class="col-sm-12 text-center"
                          style="fontSize:1rem;fontWeight:500"
                        >{{device('total', customer._id)}}</div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="row">
                        <div
                          class="col-sm-12 total text-center"
                          style="color: rgba(83, 221, 158, 0.9);"
                        >
                          <div>Online</div>
                        </div>
                        <div
                          class="col-sm-12 text-center"
                          style="fontSize:1rem;fontWeight:500"
                        >{{device('online', customer._id)}}</div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="row">
                        <div
                          class="col-sm-12 total text-center"
                          style="color: rgba(255, 106, 106, 0.9)"
                        >
                          <div>Offline</div>
                        </div>
                        <div
                          class="col-sm-12 text-center"
                          style="fontSize:1rem;fontWeight:500"
                        >{{device('offline', customer._id)}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiCall } from "@/utils/api";
import Sidebar from "./Sidebar";

export default {
  mounted() {
    this.getAllCustomers();
  },
  data() {
    return {
      customers: [],
      activeClass: "active",
      deviceCount: {},
    };
  },
  components: {
    Sidebar,
    Notification,
  },
  methods: {
    device(type, id) {
      let compnayData = this.deviceCount[id];
      if (compnayData === undefined) {
        return "NA";
      }
      if (type === "total") {
        return compnayData.totalCount;
      } else if (type === "online") {
        return compnayData.onlineCount;
      } else if (type === "offline") {
        return compnayData.offlineCount;
      }
    },
    getAllCustomers() {
      apiCall({ url: "company", method: "get" })
        .then((resp) => {
          // console.log('resp', resp)
          this.customers = resp.data;
          this.deviceCount = resp.devicecount;
        })
        .catch((err) => {
          // console.log(err);
        });
    },
  },
};
</script>
<style>
.container-fluid {
  margin: 0px;
  padding: 0px;
}
.card {
  background: #fff;
  box-shadow: 0 0 0.62rem 0 rgba(0, 0, 0, 0.2);
  border-radius: 0.62rem;
  width: 100%;
  /* height: 8rem; */
  font-family: Ubuntu;
  font-size: 10px;
  color: rgba(59, 59, 59, 0.8);
}
.card-title {
  text-transform: capitalize;
  font-family: Ubuntu;
  font-size: 1.4rem;
  color: rgba(59, 59, 59, 0.8);
}
.card-text {
  word-wrap: break-word;
  font-size: 0.8rem !important;
}
.card-body {
  padding: 0px;
}
.row {
  margin-left: 0px;
  margin-right: 0px;
}
.custNm {
  text-transform: capitalize;
}
.cust {
  font-family: Ubuntu;
  font-weight: 200;
  color: rgba(59, 59, 59, 0.8);
}
.custcol {
  box-shadow: 0 0 0.62rem 0 rgba(0, 0, 0, 0.2);
  border-radius: 0.62rem;
}
.status-cont {
  padding: 0.5rem !important;
}
.total {
  padding: 0px !important;
  font-size: 0.8rem;
}
a {
  text-decoration: none !important;
}
</style>
